import { c as _c } from "react/compiler-runtime";
import React from 'react';
export const BoldIcon = React.forwardRef<SVGSVGElement>((props, ref) => {
  const $ = _c(4);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <path fillRule="evenodd" clipRule="evenodd" d="M6.75 6.5C6.75 5.534 7.534 4.75 8.5 4.75H12.051C14.186 4.75 15.9 6.5 15.9 8.638C15.9015 9.66045 15.5015 10.6426 14.786 11.373C15.5183 11.6931 16.1414 12.2197 16.579 12.8884C17.0166 13.5571 17.2498 14.3388 17.25 15.138C17.2479 16.2302 16.8122 17.2768 16.0387 18.0479C15.2652 18.8189 14.2172 19.2513 13.125 19.25H8.5C8.03587 19.25 7.59075 19.0656 7.26256 18.7374C6.93437 18.4092 6.75 17.9641 6.75 17.5V6.5ZM8.25 12.526V17.5C8.25 17.638 8.362 17.75 8.5 17.75H13.125C13.8193 17.7513 14.4858 17.477 14.978 16.9872C15.4702 16.4975 15.7479 15.8323 15.75 15.138C15.7479 14.4437 15.4702 13.7785 14.978 13.2888C14.4858 12.799 13.8193 12.5247 13.125 12.526H8.25ZM8.25 11.026H12.051C13.34 11.026 14.4 9.966 14.4 8.638C14.4 7.31 13.34 6.25 12.051 6.25H8.5C8.4337 6.25 8.37011 6.27634 8.32322 6.32322C8.27634 6.37011 8.25 6.4337 8.25 6.5V11.026Z" fill="currentColor" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] !== props || $[2] !== ref) {
    t1 = <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props} ref={ref}>{t0}</svg>;
    $[1] = props;
    $[2] = ref;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  return t1;
});
export default BoldIcon;